/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromTeamSelectionModal from 'app/shared/store/actions/team-selection-modal.action';

export interface TeamSelectionModalState {
  [x: string]: any;
  visible: boolean;
  eventId: number;
  eventData: any;
  teamId: number;
  isAthleteSport: boolean;
  forbiddenTeam: boolean;
}

export const initialState = {
  visible: false,
  eventId: null,
  eventData: null,
  teamId: null,
  isAthleteSport: false,
  forbiddenTeam: false,
};

export function reducer(
  state = initialState,
  action: fromTeamSelectionModal.TeamSelectionAction
): TeamSelectionModalState {
  // tslint:disable-next-line:no-small-switch
  switch (action.type) {
    case fromTeamSelectionModal.SHOW_TEAM_SELECTION_MODAL: {
      return {
        ...state,
        visible: true,
        eventData: action.payload.eventData,
        eventId: action.payload.eventId,
        isAthleteSport: action.payload.isAthleteSport,
        forbiddenTeam: action.payload.forbiddenTeam,
        navigateToGames: action.payload.navigateToGames,
        notification: action.payload.notification,
      };
    }

    case fromTeamSelectionModal.HIDE_TEAM_SELECTION_MODAL: {
      return {
        ...state,
        ...initialState,
        visible: false,
        teamId: action.payload.teamId || null,
      };
    }
  }
  return state;
}

export const getTeamSelectionModalState = (state: TeamSelectionModalState) => state;
